import Main from './Main'
import Lista from './components/Categorias'
import Novo from './components/NovaCategoria'

export default [
  {
    path: 'categorias-veiculares',
    name: 'config.categorias.veiculares',
    component: Main,
    redirect: { name: 'config.categorias.veiculares.list' },
    children: [
      {
        path: '/',
        name: 'config.categorias.veiculares.list',
        component: Lista
      },
      {
        path: 'registro',
        name: 'config.categorias.veiculares.novo',
        component: Novo
      },
      {
        path: ':id',
        name: 'config.categorias.veiculares.edit',
        component: Novo
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/app/configuracoes/categorias-veiculares/routes.js